module.exports = __webpack_public_path__ + "static/media/erdem.a9a41091.jpg";